import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'SmashCore',
  brandName: 'SmashCore',
  description: 'Sistema de agendamento para treinadores de padel',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Quadra de padel',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Treinador dando aula de padel',
  },
  testimonials: [
    {
      name: 'Tomás Silva',
      role: 'Treinador de Padel',
      text: 'O SmashCore facilita a marcação de aulas e a gestão dos campos. Os meus alunos adoram a simplicidade.',
      image: testimonial1,
    },
    {
      name: 'Inês Martins',
      role: 'Jogadora de Padel',
      text: 'Marcar aulas de padel nunca foi tão fácil. Consigo ver a disponibilidade do meu treinador em tempo real.',
      image: testimonial2,
    },
    {
      name: 'Clube de Padel Top',
      role: 'Gerente do Clube',
      text: 'Excelente sistema para gerir todos os nossos treinadores e reservas de campos. Altamente recomendado.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'treinador de padel',
    professionals: 'treinadores de padel',
    business: 'clube',
    businesses: 'clubes',
    service: 'aula',
    services: 'aulas',
    client: 'jogador',
    clients: 'jogadores',
    appointment: 'treino',
    appointments: 'treinos',
  },
  homepage: {
    hero: {
      badge: 'Padel Profissional',
      title: 'Domine os courts com SmashCore',
      description: 'Organize suas aulas de padel e eleve o nível dos seus jogadores com o SmashCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '240+', label: 'Treinadores de Padel' },
      { value: '20k+', label: 'Aulas Realizadas' },
      { value: '96%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Gestão de Courts',
        description: 'Coordenar horários de múltiplos courts e treinadores gera conflitos e confusão.',
        icon: 'Calendar',
        quote: {
          text: 'Antes do SmashCore perdia 2 horas diárias resolvendo conflitos de horários nos 6 courts',
          author: 'Carlos Mendes',
          business: 'Padel Academy Porto',
        },
      },
      {
        title: 'Aulas em Grupo vs Individual',
        description: 'Gerir diferentes tipos de aulas e níveis de jogadores manualmente é complexo.',
        icon: 'Users',
        stats: [
          { label: 'Tempo gasto organizando grupos:', value: '90min/dia' },
          { label: 'Conflitos de nível em grupos:', value: '25%' },
        ],
      },
      {
        title: 'Evolução dos Jogadores',
        description: 'Acompanhar o progresso técnico individual sem registo organizado é difícil.',
        icon: 'TrendingUp',
        quote: {
          text: 'Com o histórico de evolução posso personalizar treinos e acelerar o progresso',
          author: 'Sofia Pereira',
          business: 'Elite Padel Club',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'SmashCore: O seu parceiro de court',
      description: 'Tecnologia desenvolvida para treinadores que querem maximizar o potencial dos jogadores.',
      features: [
        {
          title: 'Reserva Inteligente de Courts',
          description: 'Otimize automaticamente o uso de courts baseado no tipo de aula e número de jogadores.',
        },
        {
          title: 'Gestão de Grupos e Níveis',
          description: 'Organize jogadores por nível e crie grupos equilibrados para melhor aprendizagem.',
        },
        {
          title: 'Tracking de Evolução',
          description: 'Acompanhe o progresso técnico e tático de cada jogador com relatórios detalhados.',
        },
      ],
    },
    testimonials: {
      title: 'O que os treinadores de padel dizem',
      description: 'Treinadores que elevaram seu ensino com o SmashCore.',
    },
    finalCta: {
      title: 'Pronto para dominar os courts?',
      description: 'Junte-se aos treinadores que já otimizaram seu ensino com o SmashCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de treinador de padel',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
